import { render } from "./OrganizersList.vue?vue&type=template&id=675c9b38"
import script from "./OrganizersList.vue?vue&type=script&lang=js"
export * from "./OrganizersList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__